function Faq ()
{
    return (
        <div>
            FAQ
        </div>
    );
}

export default Faq;